(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zap-multibuy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zap-multibuy')) {
    customElements.define('zap-multibuy', class extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode;
        this.tiers = (this.dataset.tiers || '').split(',').filter(Boolean)
          .map((t) => t.split(':').map(Number)).filter(([q, p]) => q > 0 && p > 0)
          .map(([qty, pct]) => ({ qty, pct })).sort((a, b) => a.qty - b.qty);
        this.ids = new Set((this.dataset.ids || '').split(',').filter(Boolean).map(Number));
        this.price = parseInt(this.dataset.price, 10) || 0;
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.rows = Array.from(this.querySelectorAll('.zmb__row'));
        this.rows.forEach((row) => row.addEventListener('click', () => this.choose(parseInt(row.dataset.qty, 10))));
        this.querySelectorAll('[data-quick]').forEach((btn) => btn.addEventListener('click', () => this.quickAdd(btn)));
        this.unsubs = [];
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubs.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh()));
          if (this.mode === 'pdp') {
            this.unsubs.push(subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event && event.data && event.data.variant;
              if (!variant) return;
              this.price = variant.price;
              this.dataset.variantTitle = variant.title;
              this.renderPrices();
              this.updateNote();
            }));
          }
        }
        this.onCartChanged = () => this.refresh();
        document.addEventListener('zap:cart-changed', this.onCartChanged);
        if (this.mode === 'pdp') {
          this.onQtyChange = (event) => {
            if (event.target && event.target.name === 'quantity' && event.target === this.qtyInput()) this.highlight(parseInt(event.target.value, 10) || 1);
          };
          document.addEventListener('change', this.onQtyChange);
        }
        this.refresh();
      }
      disconnectedCallback() {
        this.unsubs.forEach((u) => typeof u === 'function' && u());
        document.removeEventListener('zap:cart-changed', this.onCartChanged);
        if (this.onQtyChange) document.removeEventListener('change', this.onQtyChange);
      }
      money(cents) {
        const value = (cents / 100).toFixed(2);
        const format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '').trim();
        if (!format) return `£${value}`;
        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount\s*\}\}/, value);
      }
      word(n) { return n === 1 ? (this.dataset.wordOne || 'stick') : (this.dataset.word || 'sticks'); }
      form() {
        const id = this.dataset.form;
        return (id && document.getElementById(id)) || null;
      }
      qtyInput() {
        const id = this.dataset.form;
        if (!id) return null;
        return document.querySelector(`input[name="quantity"][form="${id}"]`) || (this.form() && this.form().querySelector('input[name="quantity"]'));
      }
      choose(qty) {
        let input = this.qtyInput();
        if (!input && this.form()) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          this.form().appendChild(input);
        }
        if (input) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.highlight(qty);
      }
      highlight(qty) {
        let active = this.rows[0];
        this.rows.forEach((row) => { if (qty >= parseInt(row.dataset.qty, 10)) active = row; });
        this.rows.forEach((row) => {
          const on = row === active;
          row.classList.toggle('is-active', on);
          row.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.chosen = qty;
        this.updateNote();
      }
      updateNote() {
        const note = this.querySelector('[data-note]');
        if (!note) return;
        if (!this.chosen || this.chosen < 2) {
          note.textContent = 'Mix shades and skin tones: every stick in your basket counts towards the saving.';
        } else {
          const title = this.dataset.variantTitle && !/default title|single/i.test(this.dataset.variantTitle) ? ` × ${this.dataset.variantTitle}` : '';
          note.textContent = `Adds ${this.chosen}${title}. Want to mix shades instead? Add them one by one below.`;
        }
      }
      renderPrices() {
        this.querySelectorAll('[data-each]').forEach((el) => {
          const pct = parseInt(el.dataset.each, 10) || 0;
          el.textContent = this.money(Math.round(this.price * (100 - pct) / 100));
        });
      }
      async refresh() {
        const box = this.querySelector('[data-progress]');
        if (!box) return;
        let cart;
        try {
          const res = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } });
          cart = await res.json();
        } catch (e) { return; }
        const count = (cart.items || []).filter((i) => this.ids.has(i.product_id)).reduce((sum, i) => sum + i.quantity, 0);
        this.render(count);
      }
      render(count) {
        const box = this.querySelector('[data-progress]');
        const text = this.querySelector('[data-progress-text]');
        const fill = this.querySelector('[data-fill]');
        if (!box || !this.tiers.length) return;
        const top = this.tiers[this.tiers.length - 1];
        let current = null;
        this.tiers.forEach((t) => { if (count >= t.qty) current = t; });
        const next = this.tiers.find((t) => t.qty > count);
        if (fill) fill.style.width = `${Math.min(count / top.qty, 1) * 100}%`;
        this.querySelectorAll('[data-step]').forEach((step) => step.classList.toggle('is-reached', count >= parseInt(step.dataset.step, 10)));
        if (count === 0) {
          box.hidden = this.mode === 'pdp';
          text.textContent = `Add any ${this.tiers[0].qty} ${this.word(this.tiers[0].qty)} to save ${this.tiers[0].pct}%`;
          return;
        }
        box.hidden = false;
        if (next) {
          const more = next.qty - count;
          text.textContent = `${count} ${this.word(count)} in your basket. Add ${more} more to save ${next.pct}%${current ? ` (you're saving ${current.pct}% now)` : ''}.`;
        } else {
          text.textContent = `${count} ${this.word(count)} in your basket: you're getting our best saving, ${current.pct}% off.`;
        }
      }
      async quickAdd(btn) {
        const id = Number(btn.dataset.quick);
        if (!id) return;
        btn.setAttribute('aria-busy', 'true');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const canNotify = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function' && !/\/cart\/?$/.test(window.location.pathname);
        try {
          let data;
          if (canNotify) {
            const body = new FormData();
            body.append('id', id);
            body.append('quantity', 1);
            body.append('sections', cart.getSectionsToRender().map((s) => s.id));
            body.append('sections_url', window.location.pathname);
            const res = await fetch(`${this.root}cart/add`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
            data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || 'add failed');
            try { cart.renderContents(data); cart.classList.remove('is-empty'); } catch (e) { /* the cart pop-up is optional */ }
          } else {
            const res = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
            data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || 'add failed');
          }
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1600);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zap-multibuy', productVariantId: id, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('zap:cart-changed'));
          if (!canNotify && /\/cart\/?$/.test(window.location.pathname) && !document.querySelector('cart-items, zap-cart')) window.location.reload();
        } catch (e) {
          btn.classList.remove('is-added');
          const title = this.querySelector('.zmb__quick-title');
          if (title) title.textContent = (e && e.message) || 'Sorry, that could not be added.';
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zap-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.zapQuickAdd) return;
    window.zapQuickAdd = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[data-zap-quick-add]');
      if (!form) return;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('.zap-card__error');
      if (error) { error.hidden = true; error.textContent = ''; }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      const body = new FormData(form);
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      let data;
      try {
        const res = await fetch(`${root}cart/add`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
        data = await res.json();
        if (!res.ok || data.status) {
          if (error) { error.textContent = data.description || data.message || 'Sorry, this could not be added.'; error.hidden = false; }
          return;
        }
      } catch (e) {
        form.removeAttribute('data-zap-quick-add');
        form.submit();
        return;
      } finally {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
      try {
        cart.renderContents(data);
        cart.classList.remove('is-empty');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zap-product-card', productVariantId: data.variant_id || data.id, cartData: data });
        }
      } catch (e) {
        window.location.href = (window.routes && window.routes.cart_url) || `${root}cart`;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
